<template>
    <v-flex xs12 pb-3 v-if="permissaoAnalisaSolicitacao || contTipoArquivo.apolice > 0 ">
        <v-toolbar height="56" color="primary">
            <v-toolbar-title class="subheading white--text">
                Apólice
            </v-toolbar-title>
        </v-toolbar>
        <v-card>
            <v-card-text>
                <v-layout row wrap>
                    <v-flex xs12>
                        <span v-if="arquivos.length == 0">Nenhum arquivo para ser exibido</span>
                        <v-list two-line class="pa-0" id="listaDeArquivos">
                            <template v-for="(arquivo, index) in arquivos">
                              <div :key="arquivo.id">
                                <v-list-tile>
                                    <v-list-tile-content>
                                        <v-list-tile-title>{{arquivo.descricao}}</v-list-tile-title>
                                        <v-list-tile-sub-title>{{toLocaleDateTimeString(arquivo.dataCriacao)}}</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action>
                                        <v-layout row wrap>
                                            <v-flex xs8>
                                              <v-tooltip bottom color="blue darken-1"> 
                                                <v-btn icon slot="activator" :class="`btnDownloadArquivo-${index}`" color="transparent" @click.native="downloadArquivo(index)">
                                                    <v-icon medium color="blue darken-1">get_app</v-icon>
                                                </v-btn>
                                                <div style="text-align: center;">Download</div>
                                              </v-tooltip>
                                            </v-flex>
                                            <v-flex xs4 v-if="permissaoAnalisaSolicitacao">
                                              <v-tooltip bottom color="error">  
                                                <v-btn icon slot="activator" :class="`btnExcluirArquivo-${index}`" color="transparent" @click.native="verificaExclusao(index)">
                                                    <v-icon medium color="error">delete</v-icon>
                                                </v-btn>
                                              <div style="text-align: center;">Excluir</div>
                                            </v-tooltip>
                                            </v-flex>
                                            <v-flex xs4 v-else>
                                                <v-btn icon color="transparent" disabled>
                                                    <v-icon medium></v-icon>
                                                </v-btn>
                                            </v-flex>
                                        </v-layout>
                                    </v-list-tile-action>
                                </v-list-tile>
                                <v-flex v-if="index+1 != arquivos.length">
                                  <v-divider></v-divider>
                                </v-flex>
                              </div>
                            </template>
                        </v-list>
                    </v-flex>
                    <v-flex xs12 v-if="permissaoAnalisaSolicitacao">
                        <v-btn
                        :block="$vuetify.breakpoint.xsOnly"
                        :disabled="model.status.id != eStatusComputed.statusEnum.APOLICE_EM_EMISSAO 
                          && model.status.id != eStatusComputed.statusEnum.ENCERRADO"
                        class="white--text right"
                        @click.native="modalUpload = true"
                        id="btnEnviarArquivo"
                        color="primary">
                            Enviar
                            <v-icon right class="hidden-sm-and-down">backup</v-icon>
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>
        <v-dialog v-model="modalUpload" max-width="500px" persistent>
            <v-card>
                <v-card-title class="title  justify-space-between primary--text">
                  <span>&nbsp; Upload de Apólice</span>
                </v-card-title>
                <v-card-text>
                    <v-container grid-list-lg>
                        <v-form ref="formEnvioArquivo" v-model="formEnvioArquivoValid" enctype="multipart/form-data">
                            <v-layout row wrap>
                                <v-flex xs12>
                                    <vue-dropzone ref="dropzoneRef"
                                        id="dropzone"
                                        :options="dropzoneOptions"
                                        @vdropzone-sending="uploadArquivo"
                                        @vdropzone-file-added="arquivoSelecionado = true"
                                        @vdropzone-removed-file="arquivoSelecionado = false"
                                        @vdropzone-success="finalizaUpload"
                                        @vdropzone-error="uploadError">
                                    </vue-dropzone>
                                </v-flex>
                                <template v-if="arquivoSelecionado">
                                    <v-flex xs12 sm5>
                                        <v-select label="Tipo de arquivo"
                                            id="lstTipoArquivo"
                                            v-model="arquivoModel.tipoArquivo"
                                            :items="tiposArquivos"
                                            item-text="descricao"
                                            :rules="formRulesComputed.arquivo.tiposArquivo(arquivoModel.tipoArquivo)"
                                            return-object>
                                        </v-select>
                                    </v-flex>
                                    <v-flex xs12 sm7>
                                        <v-text-field label="Descrição"
                                            id="txtDescricaoArquivo"
                                            v-model="arquivoModel.descricao"
                                            :rules="formRulesComputed.arquivo.descricao(arquivoModel.descricao)">
                                        </v-text-field>
                                    </v-flex>
                                </template>
                            </v-layout>
                        </v-form>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-btn flat
                        id="btnFecharModal"
                        @click.native="modalUpload = false" 
                        color="primary">
                            Fechar
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn 
                        @click.native="verificaUploadApolice"
                        id="btnUploadArquivo"
                        :disabled="!formEnvioArquivoValid 
                          || !arquivoSelecionado 
                          || enviandoArquivo 
                          || model.status.id == eStatusComputed.statusEnum.PROPOSTA_EXPIRADA" 
                        color="primary">
                            Enviar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="modalConfirmaApolice.opened" max-width="550px" persistent>
            <v-card>
                <v-toolbar height="56" color="primary">
                    <v-icon dark large>warning</v-icon>
                </v-toolbar>
                <v-card-text>
                    <h3 class="primary--text">{{modalConfirmaApolice.message}}</h3>
                    <h3 class="primary--text">Deseja continuar?</h3>
                </v-card-text>
                <br>
                <v-card-actions>
                    <v-btn flat 
                        @click.native="modalConfirmaApolice.opened = false" 
                        color="primary"
                        id="btnFecharModalConfirmacaoApolice">Não</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn 
                        @click.native="iniciaUpload"
                        id="btnUploadApolice"
                        :disabled="!formEnvioArquivoValid 
                          || !arquivoSelecionado 
                          || enviandoArquivo 
                          || model.status.id == eStatusComputed.statusEnum.PROPOSTA_EXPIRADA" 
                        color="primary">
                            Sim
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="modalAviso.opened" max-width="550px" persistent>
            <v-card>
                <v-toolbar height="56" color="primary">
                    <v-icon dark large>warning</v-icon>
                </v-toolbar>
                <v-card-text>
                    <br>
                    <h3 class="primary--text">{{modalAviso.message}}</h3>
                </v-card-text>
                <br>
                <v-card-actions>
                    <v-btn flat 
                        @click.native="fechaModalAviso" 
                        color="primary"
                        id="btnFecharModalAviso">Fechar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-snackbar
            id="snackMensagemEnvio"
            :timeout="6000"
            :color="snackbar.sucesso ? 'success' : 'error'"
            multi-line
            v-model="snackbar.visivel">
            {{ snackbar.mensagem }}
            <v-btn dark flat @click.native="snackbar.visivel = false">Fechar</v-btn>
        </v-snackbar>
    </v-flex>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import axios from 'axios'
import CustomFormat from '@/helpers/custom-format'
import arquivoHelper from '@/helpers/arquivo-helper'
import formRules from '@/helpers/form-rules';
import permissoes from '@/helpers/permissoes'
import estatus from '@/helpers/estatus'
import usuarioHelper from '@/helpers/usuario-logado';

export default {
    name: 'arquivosapolices',
    components: {
        vueDropzone: vue2Dropzone
    },
    props: ["model"],
    data: () => {
        return {
            snackbar: {
                sucesso: false,
                mensagem: '',
                visivel: false
            },
            modalUpload: false,
            modalConfirmaApolice: {
                opened: false,
                message: ''
            },
            modalAviso: {
                opened: false,
                message: '',
            },
            arquivoSelecionado: false,
            formEnvioArquivoValid: false,
            arquivoModel: {
                descricao: '',
                nomeArquivo: null,
                tipoArquivo: {}, 
                idQuestionario: null,
                tokenUsuario: null,
                mimeType: null,
                downloadLink: null,
                visualizacaoAnalista: false,
                visualizacaoCliente: false
            },
            enviandoArquivo: false,
            arquivos: [],
            contTipoArquivo: {
                apolice: 0
            },
            dropzoneOptions: {
                url: `${process.env.URL_QUESTIONARIOMS}/v1/arquivos/apolices`,
                method: 'POST',
                maxFiles: 1,
                autoProcessQueue: false,
                createImageThumbnails: false,
                addRemoveLinks: true,
                uploadMultiple: false,
                dictDefaultMessage: 'Selecione ou arraste o arquivo',
                dictRemoveFile: 'Remover arquivo',
                dictCancelUpload: 'Cancelar envio',
                dictUploadCanceled: 'Envio cancelado',
                dictCancelUploadConfirmation: 'Deseja mesmo cancelar o envio?'
            }
        }
    },
    computed: {
        permissaoAnalisaSolicitacao: function() {
          return permissoes.verificaPermissao(permissoes.SolicitacaoConsulta.ANALISA_SOLICITACAO)
        },
        usuarioHelperComputed: function () {
            return usuarioHelper;
        },
        eStatusComputed: function () {
          return estatus;
        },
        formRulesComputed: function() {
          return formRules;
        },
        tiposArquivos: function () {
          return [ { id: 2, descricao: 'Apólice' } ]
        }
    },
    watch: {
        modalUpload: function (oldValue, newValue) {
            if (oldValue && !newValue)
                this.limpaFormulario();
        }
    },
    mounted: function () {
        this.carregaArquivos();
    },
    methods: {
        carregaArquivos: function () {
            const self = this;
            axios.get(`${process.env.URL_QUESTIONARIOMS}/v1/buscaArquivos?idQuestionario=${self.model.id}`,
                {
                headers: {
                    'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
                }
            })
            .then((response) => {
                self.arquivos = response.data
                  .filter(arquivo => arquivo.tipoArquivo.id == arquivoHelper.APOLICE)
                  .sort((a, b) => { return Date.parse(b.dataCriacao) - Date.parse(a.dataCriacao); });
                self.contTipoArquivo.apolice = 0;

                for (var arquivoCont in self.arquivos) {
                    if (self.arquivos[arquivoCont].tipoArquivo.id == arquivoHelper.PROPOSTA) {
                        self.contTipoArquivo.proposta++;
                    } else if (self.arquivos[arquivoCont].tipoArquivo.id == arquivoHelper.PROPOSTA_ASSINADA) {
                        self.contTipoArquivo.propostaAssinada++;
                    } else if (self.arquivos[arquivoCont].tipoArquivo.id == arquivoHelper.APOLICE) {
                        self.contTipoArquivo.apolice++;
                    }
                }
            }).catch((error) => {
                self.snackbar.visivel = true;
                self.snackbar.sucesso = false;
                self.snackbar.mensagem = error.response.data.message;
            })
        },
        downloadArquivo: function (index) {
            const self = this;
            axios.get(
                `${process.env.URL_QUESTIONARIOMS}/v1/no-auth/downloadArquivo?id=${self.arquivos[index].id}&transportadoraNome=${self.$parent.transportadoraModel.nome}`,
                {
                    responseType: "blob",
                    headers: { 'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}` },
                })
            .then((response) => {
                if (self.permissaoAnalisaSolicitacao) {
                    self.$parent.$refs.parecerRef.atualizaStatusList();
                    self.$parent.carregaQuestionario();
                }
                const link = document.createElement('a')
                link.href = window.URL.createObjectURL(new Blob([response.data], {type: "application/pdf"}));
                link.download = response.headers.nomearquivo;
                document.body.appendChild(link)
                link.click();
            }).catch((error) => {
                self.snackbar.visivel = true;
                self.snackbar.sucesso = false;
                self.snackbar.mensagem = error.response.data.message;
            })
        },
        verificaExclusao: function (index) {
            const self = this;
            if (self.contTipoArquivo.apolice <= 1 && self.arquivos[index].tipoArquivo.id == arquivoHelper.APOLICE) {
                self.modalAviso.message = 'Para excluir a Apólice você deve anexar outra antes.';
                self.modalAviso.opened = true;
            } else {
                self.excluirArquivo(index);
            }
        },
        fechaModalAviso: function () {
            const self = this;
            self.modalAviso.message1 = '';
            self.modalAviso.message2 = '';
            self.modalAviso.opened = false;
        },
        excluirArquivo: function (index) {
            const self = this;
            var tipoArquivo = self.arquivos[index].tipoArquivo.id;
            axios.delete(`${process.env.URL_QUESTIONARIOMS}/v1/excluiArquivo?id=${self.arquivos[index].id}&transportadoraNome=${self.$parent.transportadoraModel.nome}&usuarioPerfil=${usuarioHelper.USUARIO_LOGADO().perfil.id}`, 
                {
                headers: {
                    'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
                }
            })
            .then((response) => {
                if (response.data == true) {
                    self.carregaArquivos();
                }
                self.snackbar.visivel = true;
                self.snackbar.sucesso = response.data;
                self.snackbar.mensagem = response.data ? 
                    'Arquivo excluído com sucesso.' :
                    'Exclusão negada: você não enviou este arquivo.';
            }).catch((error) => {
                self.snackbar.visivel = true;
                self.snackbar.sucesso = false;
                self.snackbar.mensagem = error.response.data.message;
            })
        },
        limpaFormulario: function () {
            this.$refs.formEnvioArquivo.reset();
            this.$refs.dropzoneRef.removeAllFiles(true);
            this.enviandoArquivo = false;
        },
        verificaUploadApolice: function () {
            const self = this;
            if (self.arquivoModel.tipoArquivo.id == arquivoHelper.APOLICE) {
                self.modalConfirmaApolice.message = 'Ao anexar uma apólice, o processo de solicitação será encerrado.';
                self.modalConfirmaApolice.opened = true;
            } else {
                self.iniciaUpload();
            }
        },
        iniciaUpload: function () {
            this.$refs.dropzoneRef.processQueue();
        },
        uploadArquivo: async function (file, xhr, formData) {
            const self = this;
            self.enviandoArquivo = true;
        
            self.arquivoModel.nomeArquivo = file.name;
            self.arquivoModel.idQuestionario = self.model.id;
            self.arquivoModel.mimeType = file.type;
            self.arquivoModel.downloadLink = '';
            self.arquivoModel.visualizacaoAnalista = false;
            self.arquivoModel.visualizacaoCliente = false;
            self.arquivoModel.tokenUsuario = usuarioHelper.USUARIO_LOGADO().token;

            xhr.setRequestHeader('Authorization', `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`);
            formData.append('arquivoModel', JSON.stringify(self.arquivoModel));
            formData.append('transportadoraNome', self.$parent.transportadoraModel.nome);
            formData.append('usuarioPerfil', usuarioHelper.USUARIO_LOGADO().perfil.id);
            formData.append('usuarioNome', usuarioHelper.USUARIO_LOGADO().nome);
        },
        finalizaUpload: function (file, response) {
            const self = this;
            
            self.snackbar.visivel = true;
            self.snackbar.sucesso = response;
            self.snackbar.mensagem = response ? 
                'Arquivo enviado com sucesso.' :
                'Houve um problema ao enviar o arquivo.';
            
            self.modalConfirmaApolice = false;
            self.modalUpload = false;

            if (response) {
                self.carregaArquivos();
                if (self.permissaoAnalisaSolicitacao) {
                    self.$parent.$refs.parecerRef.atualizaStatusList();
                }
                self.$parent.carregaQuestionario();
            }
        },
        uploadError: function (file, response) {
            const self = this;
            self.modalConfirmaApolice = false;
            self.modalUpload = false;

            self.snackbar.visivel = true;
            self.snackbar.sucesso = false;
            self.snackbar.mensagem = response.message;
        },
        toLocaleDateTimeString: function (val) {
            return CustomFormat.toLocaleDateTimeString(val);
        }        
    }
}
</script>




// WEBPACK FOOTER //
// src/components/pages/solicitacao-consulta/ArquivosApolice.vue